import { render } from "./consumelist.vue?vue&type=template&id=0416f235"
import script from "./consumelist.vue?vue&type=script&lang=js"
export * from "./consumelist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__